import * as React from "react";
import { Grid, DialogContent } from "@material-ui/core";
import './BaseModal.scss'

export interface IBaseModalContentPros {
    children: React.ReactNode;
}

export const BaseModalContent:React.FC<IBaseModalContentPros> = (props) => { 
    return (
      <DialogContent className="confirm-modal-content">
        <Grid container={true} spacing={16}>                                                        
             {props.children}     
        </Grid>   
      </DialogContent>
    )
}


// WEBPACK FOOTER //
// ./src/component/shared/base-modal/BaseModalContent.tsx